// extracted by mini-css-extract-plugin
export default {"hero":"hero_hero__5mttg","ContentWrapper":"hero_ContentWrapper__oZzAd","SubTitle":"hero_SubTitle__FAcJp","Content":"hero_Content__H4XWX","Row":"hero_Row__nNqHH"};